import H5VideoTemplate from '../../../component/template/H5VideoTemplate'

class Tpl1 extends H5VideoTemplate{
    constructor(...props) {
        super(...props)
    }

    /**
     * 初始化
     * @return
     */
    init() {
        // 调用父类通用的init方法，处理初始化操作
        super.init()

        // 添加自身特有的初始化操作
        console.log('具体实现')
    }

    initComponents() {
        super.initComponents()
        // cta banner组件初始化 - START
        // this.banner = new Banner()
        // cta banner组件初始化 - END

        // H5 Video组件初始化 - START
        // Video组件挂载
        // this.playerView.mountTo(document.querySelector('#video-container'));
        // H5 Video组件初始化 - END

        // IV/RV弹窗组件初始化 - START
        // this.panel = new Pannel()
        // IV/RV弹窗组件初始化 - END
    }

    bindPageEvent() {

    }

    /**
     * 绑定事件
     * @return
     */
    bindEvent(){
        console.log('要监听的页面内事件')
    }

    /**
     * 安装
     * @param any
     */
    //@report([])
    install() {
        console.log('Install实现，记得注释上报')
        return true
    }

    destory() {
        super.destory()
        this.banner && this.banner.destory()
        this.pannel && this.pannel.destory()
    }

    _isLoadFinish() {
        return super._isLoadFinish()
    }
}

export default Tpl1